import { NativeTypes } from 'react-dnd-html5-backend'
export const FILE: typeof NativeTypes.FILE = NativeTypes.FILE
export const ARTIST = 'artist'
export const TRACK = 'track'
export const UPLOAD = 'upload'
export const PLAYLIST = 'playlist'
export const BRIEF = 'brief'
export const GROUP = 'group'
export const MIXED_LIST = 'list'
export const SECTION = 'SECTION'
export const ALBUM = 'album'
export const COPY_METADATA_SOURCE = 'COPY_METADATA_SOURCE'
export const COPY_METADATA_TARGET = 'COPY_METADATA_TARGET'
export const TABLE_COLUMN = 'TABLE_COLUMN'

export type ItemTypes =
  | typeof FILE
  | typeof ARTIST
  | typeof TRACK
  | typeof UPLOAD
  | typeof PLAYLIST
  | typeof GROUP
  | typeof MIXED_LIST
  | typeof SECTION
  | typeof ALBUM
  | typeof COPY_METADATA_SOURCE
  | typeof COPY_METADATA_TARGET
  | typeof TABLE_COLUMN
